import { getListName } from 'analytics/enhanced-ecommerce'
import OfferCardCarouselSection from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'
import { OfferListEventsProvider } from 'components/OfferList/OfferListEventsContext'
import { useExperienceLuxPlusCarouselProps } from 'hooks/Experiences/useExperienceLuxPlusCarouselProps'
import useOfferListTracking from 'hooks/Offers/useOfferListTracking'
import React from 'react'
import { LUX_PLUS_MONTH_CAMPAIGN_ID } from 'takeovers/luxPlusMonthTakeover/constants/luxPlusMonthTakeoverConstants'

const CAMPAIGNS = [LUX_PLUS_MONTH_CAMPAIGN_ID]

interface Props {
  analyticsPage: string
}

function LuxPlusMonthExperiencesOfferCarousel({ analyticsPage }: Props) {
  const experienceLuxPlusCarouselProps = useExperienceLuxPlusCarouselProps({
    title: <><i>More</i> local experiences</>,
    campaigns: CAMPAIGNS,
    carouselId: 'local_experiences',
  })
  const tracking = useOfferListTracking(getListName('OfferList', analyticsPage, 'Discounted experiences'))
  if (!experienceLuxPlusCarouselProps) return null

  return <OfferListEventsProvider tracking={tracking}>
    <OfferCardCarouselSection {...experienceLuxPlusCarouselProps} />
  </OfferListEventsProvider>
}

export default LuxPlusMonthExperiencesOfferCarousel
